import { css } from "styled-components";

export const BackdropStyles = css(
    ({ theme }) => css`
        .Backdrop {
            height: 100%;
        }
        ${theme.breakpoints.up("maxPageWidth")} {
            .Backdrop {
                width: 100%;
                height: 100%;
                max-width: ${theme.breakpoints.values.maxPageWidth}px;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
        @media screen and (orientation: landscape) and (max-width: ${theme.breakpoints.values.sm}px) {
            .Backdrop {
                max-width: 100%;
            }
        }
    `,
);
